'use client'

import { useEffect, useState, useRef } from "react";
import styles from "./NossosNumeros.module.css";

const numeros = [
  { id: 1, icone: "book", valor: 17, sufixo: "mil", descricao: "títulos disponíveis" },
  { id: 2, icone: "book-open", valor: 40, sufixo: "", descricao: "áreas de conhecimento" },
  { id: 3, icone: "users", valor: 4, sufixo: "milhões", descricao: "de usuários ativos" },
  { id: 4, icone: "graduation-cap", valor: 950, sufixo: "", descricao: "instituições parceiras" },
];

const NossosNumeros = () => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const [valoresAtuais, setValoresAtuais] = useState<{ [key: number]: number }>(
    numeros.reduce((acc, item) => ({ ...acc, [item.id]: 0 }), {})
  );

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          iniciarAnimacao();
        } else {
          resetarValores();
        }
      },
      { threshold: 0.3 } // Ativa quando 30% da seção estiver visível
    );

    observer.observe(section);

    return () => observer.unobserve(section);
  }, []);

  const iniciarAnimacao = () => {
    const intervalos = numeros.map(({ id, valor }) => {
      let contador = 0;
      const incremento = Math.ceil(valor / 100);

      const intervalo = setInterval(() => {
        contador += incremento;
        if (contador >= valor) {
          contador = valor;
          clearInterval(intervalo);
        }
        setValoresAtuais((prev) => ({ ...prev, [id]: contador }));
      }, 30);

      return intervalo;
    });

    return () => intervalos.forEach(clearInterval);
  };

  const resetarValores = () => {
    setValoresAtuais(numeros.reduce((acc, item) => ({ ...acc, [item.id]: 0 }), {}));
  };

  return (
    <section ref={sectionRef} className={styles.NossoNumeros}>
      <div className={styles.boxNossoNumeros}>
        <div className={styles.dFlex}>
          {numeros.map(({ id, icone, sufixo, descricao }) => (
            <div key={id} className={styles.itemNumeros}>
              <div className={styles.icon}>
                <img src={`./images/numerosbv/${icone}.svg`} alt={`Ícone ${descricao}`} aria-label={`Ícone ${descricao}`} loading="lazy" />
              </div>
              <div className={styles.contentNumeros}>
                <div className={styles.number}>
                  <span tabIndex={0}>+</span>
                  <h3 tabIndex={0}>{valoresAtuais[id]}</h3>
                  {sufixo && <h4 tabIndex={0}>{sufixo}</h4>}
                </div>
                <div className={styles.chamada}>
                  <p tabIndex={0}>{descricao}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NossosNumeros;